import MobxTextInput from './MobxTextInput'

export default MobxTextInput
